(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('UnsoopifyPlanController', UnsoopifyPlanController);

    UnsoopifyPlanController.$inject = ['$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning'];
    
    function UnsoopifyPlanController($uibModalInstance, parameters, SoopkitchenUtils, Planning) {

        var vm = this;
        vm.labelToUnsoopify = parameters.labelToUnsoopify;
        vm.internalVersionToUnsoopify = parameters.internalVersionToUnsoopify;
        vm.planLabel = null;
        vm.save = save;
        vm.clear = clear;
        
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            Planning.unsoopify(
                {
                    planLabel: vm.planLabel,
                    planLabelToUnsoopify : vm.labelToUnsoopify,
                    internalVersionToUnsoopify : vm.internalVersionToUnsoopify,
                },
                function successCallback(response) {
                    $uibModalInstance.dismiss('cancel');
                }, function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response);
                }
            );
        }
    }
})();
